import $ from 'jquery';
import stickybits from 'stickybits';


/* Global variables
********************************************/


/* Sticky sidebars
********************************************/

if ($('.js-sticky-widget').length) {
	stickybits( '.js-sticky-widget', {
		//useStickyClasses: true,
		//useFixed: true,
		stickyBitStickyOffset: 20,
		//customStickyChangeNumber: 10
	});
}
